import { Component, OnDestroy, OnInit } from '@angular/core';
import { TOAST_POSITION_TO_CLASSES } from '@app/modules/toasts/models/constants/toast.constants';
import { ToastConfig, ToastPosition } from '@app/modules/toasts/models/interfaces/toast.interfaces';
import { ToastService } from '@app/modules/toasts/services/toast.service';
import { Subject, takeUntil, tap } from 'rxjs';

@Component({
    selector: 'fdx-toast-container',
    templateUrl: './toast-container.component.html',
    styleUrl: './toast-container.component.scss',
    standalone: false
})
export class ToastContainerComponent implements OnInit, OnDestroy {

    private readonly unsubscribe$: Subject<void> = new Subject<void>();

    position: ToastPosition;
    toasts: ToastConfig[] = [];

    get positionClasses(): string {
        return TOAST_POSITION_TO_CLASSES.get(this.position);
    }

    constructor(
        private readonly toastService: ToastService
    ) { }

    ngOnInit(): void {
        this.toastService.toastPosition$.pipe(
            tap((position) => {
                this.position = position;
            }),
            takeUntil(this.unsubscribe$)
        ).subscribe();

        this.toastService.toasts$.pipe(
            tap((toasts) => {
                this.toasts = toasts;
            }),
            takeUntil(this.unsubscribe$)
        ).subscribe();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
